// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3lFBe","content":"ManualTimeModal_content__3q7u8"};